export default {
  GROWING: 'growing',
  STARTER: 'starter'
}
